export default __webpack_public_path__ + "static/media/roboto-v20-latin-300italic.574b45dd.ttf";